import { createRoot } from '@wordpress/element';
import SetupWizard from './setup-wizard/SetupWizard';
import '../../css/setup-wizard.css';

document.addEventListener('DOMContentLoaded', () => {
    const container = document.getElementById('nemtly-booking-setup-wizard');

    if (container) {
        const root = createRoot(container);
        root.render(<SetupWizard />);
    }
});
